import React from 'react';
import { useIsMobile } from '../../Hooks/useIsMobile';

const Footer = ({className}) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <footer className={`bg-white py-8 px-4 ${className}`}>
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 gap-2 text-center">
            {/* Copyright Section */}
            <div className="space-y-2">
              <p className="text-sm text-text-primary">
                © 2026 Biziverse Pvt. Ltd.
              </p>
              <a 
                href="/policy.pdf" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-sm text-primary underline transition-colors inline-block"
              >
                Privacy Policy
              </a>
            </div>
            
            {/* Address Section */}
            <div className="text-sm text-text-primary">
              <p>A/44 GIDC Electronics Estate,</p>
              <p>Gandhinagar, GJ 382016 INDIA</p>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  return (
    <footer className={`bg-[#f0f1f3] border-t border-[#ddd] py-4 px-6 ${className}`}>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 gap-0 text-center">
          {/* Copyright Section */}
          <div className="text-sm text-[#333] text-start">
            <span>© 2026 Biziverse Pvt. Ltd.</span>
            <span className="mx-2">•</span>
            <a 
              href="/policy.pdf" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-[#333] hover:underline"
            >
              Privacy Policy
            </a>
          
          </div>
          
          {/* Address Section */}
          <div className="text-sm text-[#333] text-end">
            A/44 GIDC Electronics Estate, Gandhinagar, GJ 382016 INDIA
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;